import { render } from "./TransactionCard.vue?vue&type=template&id=ff905dba&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"

import "./TransactionCard.vue?vue&type=style&index=0&id=ff905dba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff905dba"]])

export default __exports__